(function () {
  var mainContent = document.getElementById('MainContent');
  var track = document.getElementById('FooterRevealTrack');
  var footerEl = track ? track.querySelector('.footer') : null;
  if (!mainContent || !track || !footerEl) return;

  /* Desktop reveals the footer by intercepting wheel input (scroll-jacking).
     Touch devices fire no wheel events, so on mobile we drive the reveal from
     native scroll POSITION (scroll-linked) — smooth under a finger.

     Mobile direction: the footer reads TOP-FIRST — the menu/heading appears as
     you reach it and you scroll DOWN through it to the wordmark at the very
     bottom (natural reading order; the footer moves with the finger, not
     against it). */
  var isTouch = window.matchMedia('(max-width: 749px)').matches;

  /* Mobile: render the footer as a normal in-flow block so the wordmark and all
     content always show and scroll naturally. The reveal effect is desktop-only. */
  if (isTouch) {
    document.documentElement.style.setProperty('--footer-reveal-height', '0px');
    track.style.transform = 'none';
    return;
  }

  var footerHeight = 0;
  var spacerStartY = 0;
  var sweepDist = 0; /* extra scroll distance between wordmark and heading */
  var internalProgress = 0; /* 0 = wordmark (bottom-anchored), 1 = heading (top-anchored) */
  var SENSITIVITY = 1; /* px of internal sweep per px of wheel delta (desktop) */

  /* Raw 0..1 of how far we've scrolled through the reserved sweep region. */
  function scrollFraction() {
    if (sweepDist <= 0) return 0;
    return Math.min(1, Math.max(0, (window.scrollY - spacerStartY) / sweepDist));
  }
  /* Mobile maps that INVERTED, so the heading shows first and the wordmark is
     revealed last as you scroll down. */
  function mobileProgress() {
    return 1 - scrollFraction();
  }

  function measure() {
    var viewportHeight = window.innerHeight;
    footerHeight = footerEl.getBoundingClientRect().height;
    /* A page that has no size yet (opened in a background tab, a window that hasn't laid out) reports a
       zero height. Measuring then would push the footer out of sight for good, so skip it and wait for the
       next measurement; the stylesheet's fallback keeps the room for the footer in the meantime. */
    if (!viewportHeight || !footerHeight) return;
    sweepDist = Math.max(0, footerHeight - viewportHeight);
    /* Native scroll reserves one viewport (to uncover the pinned position). On
       mobile we also reserve the sweep distance, so ordinary touch scrolling
       drives the whole reveal instead of a wheel gesture. */
    var reserve = isTouch ? viewportHeight + sweepDist : viewportHeight;
    document.documentElement.style.setProperty('--footer-reveal-height', reserve + 'px');
    spacerStartY = mainContent.getBoundingClientRect().bottom + window.scrollY;
  }

  function render() {
    /* Not measured yet: leave the footer where it naturally sits rather than sliding it a whole screen
       below the window, where it could never be seen. */
    if (!footerHeight || !window.innerHeight) {
      track.style.transform = 'none';
      return;
    }
    var viewportHeight = window.innerHeight;
    var pinnedTop = viewportHeight - footerHeight;
    var trackTop = pinnedTop + internalProgress * (0 - pinnedTop);
    track.style.transform = 'translateY(' + trackTop + 'px)';
  }

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      if (isTouch) {
        internalProgress = mobileProgress();
      } else if (maxScroll() - window.scrollY >= window.innerHeight) {
        /* Desktop: once fully scrolled away, reset so it restarts at the
           wordmark next time (happens off-screen, so there's no visible snap). */
        internalProgress = 0;
      }
      render();
      ticking = false;
    });
  }

  /* How far the page can scroll in total, read fresh each time. A number measured once at load goes wrong as
     soon as the page above the footer gets taller or shorter (pictures, fonts and carousels settling). */
  function maxScroll() {
    return document.documentElement.scrollHeight - window.innerHeight;
  }

  function atNativeScrollCap() {
    return window.scrollY >= maxScroll() - 2; /* small tolerance for sub-pixel rounding */
  }

  function onWheel(e) {
    if (isTouch) return; /* mobile is driven by native scroll (onScroll) */
    if (!atNativeScrollCap()) return; /* let native scroll handle covering/uncovering */

    if (e.deltaY < 0 && internalProgress < 1) {
      e.preventDefault();
      internalProgress = Math.min(1, internalProgress + (-e.deltaY * SENSITIVITY) / 500);
      render();
    } else if (e.deltaY > 0 && internalProgress > 0) {
      e.preventDefault();
      internalProgress = Math.max(0, internalProgress - (e.deltaY * SENSITIVITY) / 500);
      render();
    }
  }

  function onResize() {
    isTouch = window.matchMedia('(max-width: 749px)').matches;
    measure();
    if (isTouch) internalProgress = mobileProgress();
    render();
  }

  measure();
  if (isTouch) internalProgress = mobileProgress();
  render();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onResize);
  window.addEventListener('wheel', onWheel, { passive: false });

  if (window.ResizeObserver) {
    var ro = new ResizeObserver(onResize);
    ro.observe(footerEl);
    ro.observe(mainContent);
  }

  /* Measure again whenever things may have settled or come back into view: when the page has fully
     loaded, when the fonts arrive, and when a tab opened in the background is switched to. */
  window.addEventListener('load', onResize);
  window.addEventListener('pageshow', onResize);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) onResize();
  });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(onResize);
})();
